const API_BASE_URL = 'https://api.1936663.xyz';

export const request = async (endpoint, method, body = null) => {
  const url = API_BASE_URL + endpoint;
  try {
    const options = {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    const res = await fetch(url, options);
    
    let result;
    const contentType = res.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      result = await res.json();
    } else {
      result = await res.text();
    }

    if (!res.ok) {
      throw new Error(typeof result === 'string' ? result : (result.error || result.message || 'Request failed'));
    }

    return result;
  } catch (e) {
    throw e;
  }
};
